// Store-free leaf: the users reducer needs these keys, and importing them from the
// feedback hooks drags the redux store into the reducer's own initialization and
// throws a TDZ error (Ready#7606).

export const FEEDBACK_TIMESTAMP_KEY = "mp_last_feedback"

export const LAST_USER_INITIATED_FEEDBACK_TIMESTAMP =
  "LAST_USER_INITIATED_FEEDBACK_TIMESTAMP"
